import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

export const supplierPaymentsService = {
    uploadWorkItemFiles,
    getWorkItemFileSchemas,
    uploadWorkItemFileList,
    getWorkItemFilesProgress,
    getWorkItemFileReconciliation,
    setWorkItemRowStatus,
    checkBatchNumber,
    batchItems,
    getUploadedFilesList,
    downloadBatchesForFile,
    downloadBatch,
    setBatchToPaid,
    addToBatch
}

function uploadWorkItemFiles(formData) {
    return axios({
        method: "POST",
        url: "/api/admin/v1/supplierpayments/uploadworkitemfiles",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

function getWorkItemFileSchemas() {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/workitemfileschemas"
    });
}

function uploadWorkItemFileList(formData) {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/workitemfiles",
        //data: formData,
        //headers: {
        //    "Content-Type": "multipart/form-data",
        //},
    });
}

function getWorkItemFilesProgress(payload) {
    let url = "/api/admin/v1/supplierpayments/workitemfileprogress"
    if (payload != null && payload != undefined) {
        url = url + "?uploadId=" + payload
    }
    return axios({
        method: "GET",
        url: url
    });
}

function getWorkItemFileReconciliation(payload) {
    console.log('-payload: ', payload)
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/workitemfilereconciliation/" + payload
    });
}

function setWorkItemRowStatus(payload) {
    return axios({
        method: "POST",
        url: "/api/admin/v1/supplierpayments/workitemsetstatus/",
        data: payload
    });
}

function checkBatchNumber(payload) {
    return axios({
        method: "POST",
        url: "/api/admin/v1/supplierpayments/isbatchnumbervalid/",
        data: payload
    });
}

function batchItems(payload) {
    return axios({
        method: "POST",
        url: "/api/admin/v1/supplierpayments/batchitems/",
        data: payload
    });
}

function addToBatch(payload) {
    return axios({
        method: "POST",
        url: "/api/admin/v1/supplierpayments/addtobatch/",
        data: payload
    });
}

function getUploadedFilesList() {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/getuploadedfileslist"
    });
}


function downloadBatchesForFile(id) {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/downloadbatchesforfile/" + id,
        responseType: "blob" // Important for binary data
    }).then(response => {
        // Create a blob from the response
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `SupplierPayments_${id}.csv`); // Filename
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }).catch(error => {
        console.error("Download failed:", error);
    });
}

function downloadBatch(id) {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/downloadbatchitems/" + id,
        responseType: "blob" // Important for binary data
    }).then(response => {
        // Create a blob from the response
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `SupplierPayments_${id}.csv`); // Filename
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }).catch(error => {
        console.error("Download failed:", error);
    });
}

function setBatchToPaid(payload) {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/setbatchtopaid?batchid=" + payload.batchId + "&invoicenumber=" + payload.invoiceNumber + "&paymentReference=" + payload.paymentReference
    });
}
